var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{on:{"change":_vm.handleChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},_vm._l((_vm.options),function(item){return _c('Option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }